export enum CostBasis {
  Employee = 1,
  Device = 2,
  License = 3,
  Fixed = 4,
};